import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Menhu = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb445__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb445__a)">
            <path
              fillRule="evenodd"
              d="M42.526 8.07A2 2 0 0 1 44 10v28a2 2 0 0 1-1.474 1.93l-22 6A1.998 1.998 0 0 1 18 44v-4H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h12V4a1.999 1.999 0 0 1 2.526-1.93l22 6ZM18 36V12H8v24h10Zm4-29.381 18 4.909v24.944l-18 4.91V6.619ZM26 22a2 2 0 1 1 4 0v4a2 2 0 1 1-4 0v-4Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
